export const hasExtractedValue = (value?: string) => !!value?.trim();

export const splitOverflowValues = (value: string) =>
  value
    .split(';')
    .map((entry) => entry.trim())
    .filter(Boolean);
